import './../css/aos.css';
import './../css/bootstrap.min.css';
import './../css/main.css';

import { saveAs } from 'file-saver';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarDays, faCircleLeft, faEnvelope, faPhone, faLocationDot, faHeart, faPassport } from '@fortawesome/free-solid-svg-icons'
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';

import { aboutData } from './../../Utils/data';
import { Slider } from '../Slider/Slider';

import imageProfile from './../../Images/avatar.jpg'

export const DetailsAbout = ({handleOnClick, titleClicked}) => {

    return (
        titleClicked === 3 && <div class="page-content page-about">
            <div class="container">
                <div class="cover shadow-lg bg-white">
                    <div class="cover-bg p-3 p-lg-4 text-white">
                        <FontAwesomeIcon class="back-icon" size='2xl' icon={faCircleLeft} onClick={handleOnClick} />
                        <div class="row pt-2">
                            <div class="col-lg-4 col-md-5">
                                <div class="avatar hover-effect bg-white shadow-sm p-1">
                                    <img src={imageProfile} />
                                </div>
                            </div>
                            <div class="col-lg-8 col-md-7 text-center text-md-start">
                                <h2 class="h1 mt-2" data-aos="fade-left" data-aos-delay="0">Nicolás Logosettis</h2>
                                <p data-aos="fade-left" data-aos-delay="100">Software Engineer</p>
                                <div class="d-print-none" data-aos="fade-left" data-aos-delay="200">
                                        <a href='https://drive.google.com/file/d/1bOsdXd3d0sQd4NBWVffdgntC7jahqYrI/view?usp=share_link' target='_blank' rel="noreferrer"><div class="btn btn-success text-white shadow-sm mt-1 me-1">Download CV</div></a>
                                </div>
                                <div></div>
                            </div>
                        </div>
                    </div>
                    <div class="about-section pt-4 px-3 px-lg-4 mt-1">
                        <div class="row">
                        <div class="col-md-6">
                            <p>{ aboutData.description }</p>
                        </div>
                        <div class="col-md-5 offset-md-1 icons-info">
                            <div class="row">
                            <div class="col-sm-4">
                                <div class="pb-1-custom text-end-custom about-icons"><FontAwesomeIcon icon={faCalendarDays} /></div>
                            </div>
                            <div class="col-sm-8">
                                <div class="pb-1 text-secondary">35 years old</div>
                            </div>
                            <div class="col-sm-4">
                                <div class="pb-1-custom text-end-custom about-icons"><FontAwesomeIcon icon={faHeart} /></div>
                            </div>
                            <div class="col-sm-8">
                                <div class="pb-1 text-secondary">Single</div>
                            </div>
                            <div class="col-sm-4">
                                <div class="pb-1-custom text-end-custom about-icons"><FontAwesomeIcon icon={faPassport} /></div>
                            </div>
                            <div class="col-sm-8">
                                <div class="pb-1 text-secondary">Spanish, Argentinian</div>
                            </div>
                            <div class="col-sm-4">
                                <div class="pb-1-custom text-end-custom about-icons"><FontAwesomeIcon icon={faEnvelope} /></div>
                            </div>
                            <div class="col-sm-8">
                                <div class="pb-1 text-secondary">logo.ncls@gmail.com</div>
                            </div>
                            <div class="col-sm-4">
                                <div class="pb-1-custom text-end-custom about-icons"><FontAwesomeIcon icon={faPhone} /></div>
                            </div>
                            <div class="col-sm-8">
                                <div class="pb-1 text-secondary">+54 3415967699</div>
                            </div>
                            <div class="col-sm-4">
                                <div class="pb-1-custom text-end-custom about-icons"><FontAwesomeIcon icon={faLocationDot} /></div>
                            </div>
                            <div class="col-sm-8">
                                <div class="pb-1 text-secondary">Rosario, Argentina</div>
                            </div>
                            <div class="col-sm-4">
                                <div class="pb-1-custom text-end-custom about-icons"></div>
                            </div>
                            <div class="col-sm-8 mt-1">
                                <div class="pb-1 text-secondary social-icons">
                                    <a href='https://www.linkedin.com/in/nicolas-logosettis/' target="_blank" rel="noreferrer"><FontAwesomeIcon size='2xl' icon={faLinkedin} /></a>
                                    <a href='https://github.com/nicolas-logo' target="_blank" rel="noreferrer"> <FontAwesomeIcon size='2xl' icon={faGithub} /></a>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    <hr class="d-print-none"/>
                    <div className='px-3 px-lg-4 mt-1'><h5>{aboutData.hobbies}</h5></div>
                    <Slider />
                    <div class="about-section pt-5 px-3 px-lg-4 mt-1 div-icon">
                        <FontAwesomeIcon class="back-icon-bottom" size='2xl' icon={faCircleLeft} onClick={handleOnClick} />
                    </div>
                </div>
            </div>
        </div>
    )
}